import React from 'react';
import FormatStandardDate from './FormatStandardDate';

export const ImmunityTable = (props) => {
  const rowEntries = props.immunityEventList;

  const renderImmunityTable = (rowEntries) => {
    return (
      <>
        <h4>Immunity Observation List</h4>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Vaccine Name</th>
            <th>Obs Code</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
            {rowEntries.map((row, index) => 
              (row.eventType === 3)
             ? 
            <tr key={index}>
              <td><span className="text-danger">{row.antigenName}</span></td>
              <td><span className="text-danger">{row.antigenCode}</span></td>
              <td><span className="text-danger">{FormatStandardDate(row.eventDate)}</span></td>
            </tr>
              :
            <tr key={index}>
                    <td>{row.antigenName}</td>
                    <td>{row.antigenCode}</td>
                    <td>{FormatStandardDate(row.eventDate)}</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
    );
  }

  let contents = (rowEntries === undefined) 
      ? (<p><em>Loading...</em></p>)
    : renderImmunityTable(rowEntries);

  return (
    <div>
      {contents}
    </div>
  );
}
